(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-results-grid-v2"]) return;
  try {
    
(function() {
  'use strict';

  // Configuration - Consider moving these to theme settings or metafields
  const CONFIG = {
    storefrontAccessToken: '8e6a7b3fe1fb4bf3d00695a8c81c0ef1',
    shopifyDomain: 'https://vcp-live.myshopify.com',
    apiVersion: '2023-04',
    placeholderImage: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081',
    trustpilotImage: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_ratings_4halfstar-RGB-512x96.png?v=1738852057',
    trustpilotLogo: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_brandmark_white.png?v=1738852057'
  };

  // Product type mappings
  const PRODUCT_TYPES = {
    wipers: ['Rear Blade','Rear', 'Kit', 'Set', 'Retro Upgrade Kit'],
    fuelCaps: ['Fuel Cap', 'Locking Fuel Cap', 'Non Locking Fuel Cap'],
    evCables: ['EV Charger Cable'],
    carMats: ['Car Mats']
  };

  // Collection heading mappings
  const COLLECTION_HEADINGS = {
    'wipers-for-your-vehicle': 'YOUR WIPER <br/> BLADES',
    'fuel-caps-for-your-vehicle': 'YOUR FUEL <br/> CAPS',
    'ev-charging-cables': 'YOUR EV <br/> CHARGING CABLE',
    'car-mats-for-your-vehicle': 'YOUR CAR <br/> MATS'
  };

  // Currency symbols mapping
  const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$'
  };

  /**
   * Format price with currency symbol
   */
  function formatPrice(amount, currencyCode) {
    const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode;
    return `${symbol}${amount}`;
  }

  /**
   * Get product type category
   */
  function getProductCategory(productType) {
    if (PRODUCT_TYPES.wipers.includes(productType)) return 'wipers';
    if (PRODUCT_TYPES.fuelCaps.includes(productType)) return 'fuelCaps';
    if (PRODUCT_TYPES.evCables.includes(productType)) return 'evCables';
    if (PRODUCT_TYPES.carMats.includes(productType)) return 'carMats';
    return null;
  }

  /**
   * Generate product card HTML
   */
  function createProductCard(product, variant) {
    const productImage = product.images.edges[0]?.node?.url || CONFIG.placeholderImage;
    const productLink = `/products/${product.handle}`;
    const variantIdShort = variant.id.substring(29);
    const formattedPrice = formatPrice(variant.price.amount, variant.price.currencyCode);
    const isAvailable = variant.quantityAvailable > 0;
    const category = getProductCategory(product.productType);

    const buttonHtml = isAvailable
      ? `<button id="quick-add-${variantIdShort}-submit"
            type="submit"
            name="add"
            class="quick-add__submit button button--full-width button--secondary"
            aria-haspopup="dialog"
            aria-live="polite"
            data-sold-out-message="false">
          <span>Add to cart</span>
          <div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>`
      : category === 'carMats'
        ? `<a href="${productLink}" class="quick-add__submit button button--full-width button--secondary">
            See more options
          </a>`
        : `<button id="quick-add-${variantIdShort}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-live="polite"
              data-sold-out-message="true"
              disabled>
            <span>Sold out</span>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>`;

    return `
      <li class="grid__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy" style="max-width: 100%;">
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"></div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${productLink}" class="full-unstyled-link caption-01">${product.title}</a>
                </h3>
                <div class="card__information">
                  <span class="caption-large light"></span>
                  <div class="price price--on-sale">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${formattedPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="price-item price-item--sale price-item--last heading04M">${formattedPrice}</span>
                      </div>
                      <small class="unit-price caption hidden">
                        <span class="visually-hidden">Unit price</span>
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span class="visually-hidden">&nbsp;per&nbsp;</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-add no-js-hidden">
                <product-form>
                  <form method="post" action="/cart/add" id="quick-add-${variantIdShort}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantIdShort}">
                    ${buttonHtml}
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  /**
   * Generate Your Vehicle section HTML
   */
  function createYourVehicleHtml(vehicleData, collectionHandle) {
    const headingText = COLLECTION_HEADINGS[collectionHandle] || 'YOUR VEHICLE';
    const { reg = '', make = '', model = '', body = '', fuel = '' } = vehicleData;

    return `
      <div class="inner page-width">
        <div class="guaranteed-fit body-01">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          Guaranteed Fit
        </div>
        <h2 class="display02M">${headingText}</h2>
        ${reg ? `<div class="icon-reg"><div class="your-vehicle__reg">${reg}</div></div>` : ''}
        <div class="your-vehicle__details">
          <p class="body-01">${make} ${model}<br>${body}<br>${fuel}</p>
        </div>
        <div class="your-vehicle__buttons vehicle-confirm__buttons">
          <a href="/pages/find-wiper-blades" class="button button--primary">Change my vehicle</a>
        </div>
        <div class="trustpilot">
          <p class="caption-01">
            Excellent
            <img src="${CONFIG.trustpilotImage}" alt="Trustpilot Rating">
            <a href="https://www.trustpilot.com/review/www.vipacarparts.com" target="_blank">18,065 Reviews on</a>
            <img src="${CONFIG.trustpilotLogo}" alt="Trustpilot">
          </p>
        </div>
      </div>`;
  }

  /**
   * Get vehicle data from localStorage
   */
  function getVehicleData() {
    const regResult = localStorage.getItem('regResult');
    if (regResult) {
      const data = JSON.parse(regResult);
      return {
        reg: data.reg || '',
        make: data.make || '',
        model: data.model || '',
        body: data.body || '',
        fuel: data.fuel_type || ''
      };
    }

    const manualOptions = localStorage.getItem('manual_selected_options');
    if (manualOptions) {
      const data = JSON.parse(manualOptions);
      return {
        reg: '',
        make: data.make || '',
        model: data.model || '',
        body: data.bodyStyle || '',
        fuel: data.fuelType !== '0' ? data.fuelType : ''
      };
    }

    return null;
  }

  /**
   * Get collection handle from URL
   */
  function getCollectionHandle() {
    const pathSegments = window.location.pathname.split('/');
    const collectionsIndex = pathSegments.indexOf('collections');
    return collectionsIndex !== -1 ? pathSegments[collectionsIndex + 1] : '';
  }

  /**
   * Get product IDs from URL params
   */
  function getProductIdsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const idsParam = urlParams.get('ids');
    if (!idsParam) return [];
    return idsParam.split(',').map(id => `gid://shopify/Product/${id}`);
  }

  /**
   * GraphQL query for fetching products
   */
  const PRODUCTS_QUERY = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          productType
          blade_size: metafield(namespace: "custom", key: "blade_size") {
            value
          }
          images(first: 1) {
            edges {
              node {
                id
                altText
                url(transform: { maxWidth: 400 })
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                title
                sku
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
              }
            }
          }
        }
      }
    }
  `;

  /**
   * Fetch products from Shopify Storefront API
   */
  async function fetchProducts(productIds) {
    const response = await fetch(`${CONFIG.shopifyDomain}/api/${CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.storefrontAccessToken
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: { ids: productIds }
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data.nodes.filter(Boolean);
  }

  /**
   * Render products to their respective grids
   */
  function renderProducts(products) {
    const productsByCategory = {
      wipers: [],
      fuelCaps: [],
      evCables: [],
      carMats: []
    };

    // Categorize products
    products.forEach(product => {
      if (!product || !product.variants?.edges?.length) return;

      const category = getProductCategory(product.productType);
      if (category) {
        const variant = product.variants.edges[0].node;
        productsByCategory[category].push(createProductCard(product, variant));
      }
    });

    // Render to grids
    const gridMappings = {
      wipers: 'product-grid',
      fuelCaps: 'product-grid-caps',
      evCables: 'product-grid-ev',
      carMats: 'product-grid-car-mats'
    };

    Object.entries(gridMappings).forEach(([category, gridId]) => {
      const grid = document.getElementById(gridId);
      if (grid) {
        grid.innerHTML = productsByCategory[category].join('');
      }
    });

    // Hide empty sections (title + grid container)
    const hideSectionIfEmpty = (titleId, gridId, products) => {
      if (products.length === 0) {
        const title = document.getElementById(titleId);
        const grid = document.getElementById(gridId);
        if (title) title.style.display = 'none';
        if (grid?.parentElement) grid.parentElement.style.display = 'none';
      }
    };

    hideSectionIfEmpty('car_mats_collection', 'product-grid-car-mats', productsByCategory.carMats);
    hideSectionIfEmpty('wipers_collection', 'product-grid', productsByCategory.wipers);
  }

  /**
   * Render vehicle information
   */
  function renderVehicleInfo() {
    const yourVehicleDiv = document.getElementById('your-vehicle');
    if (!yourVehicleDiv) return;

    const vehicleData = getVehicleData();
    if (!vehicleData) return;

    const collectionHandle = getCollectionHandle();
    yourVehicleDiv.innerHTML = createYourVehicleHtml(vehicleData, collectionHandle);
  }

  /**
   * Initialize the component
   */
  async function init() {
    const productIds = getProductIdsFromUrl();
    if (productIds.length === 0) return;

    try {
      const products = await fetchProducts(productIds);
      renderProducts(products);
      renderVehicleInfo();
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-results-grid"]) return;
  try {
    
(function() {
  'use strict';

  console.log('Template Updated');

  // Configuration - Consider moving these to theme settings or metafields
  const CONFIG = {
    storefrontAccessToken: '8e6a7b3fe1fb4bf3d00695a8c81c0ef1',
    shopifyDomain: 'https://vcp-live.myshopify.com',
    apiVersion: '2023-04',
    placeholderImage: 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081',
    trustpilotImage: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_ratings_4halfstar-RGB-512x96.png?v=1738852057',
    trustpilotLogo: 'https://cdn.shopify.com/s/files/1/0749/4044/9045/files/Trustpilot_brandmark_white.png?v=1738852057'
  };

  // Product type mappings
  const PRODUCT_TYPES = {
    wipers: ['Rear Blade','Rear', 'Kit', 'Set', 'Retro Upgrade Kit'],
    fuelCaps: ['Fuel Cap', 'Locking Fuel Cap', 'Non Locking Fuel Cap'],
    evCables: ['EV Charger Cable'],
    carMats: ['Car Mats']
  };

  // Collection heading mappings
  const COLLECTION_HEADINGS = {
    'wipers-for-your-vehicle': 'YOUR WIPER <br/> BLADES',
    'fuel-caps-for-your-vehicle': 'YOUR FUEL <br/> CAPS',
    'ev-charging-cables': 'YOUR EV <br/> CHARGING CABLE',
    'car-mats-for-your-vehicle': 'YOUR CAR <br/> MATS'
  };

  // Currency symbols mapping
  const CURRENCY_SYMBOLS = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$'
  };

  /**
   * Format price with currency symbol
   */
  function formatPrice(amount, currencyCode) {
    const symbol = CURRENCY_SYMBOLS[currencyCode] || currencyCode;
    return `${symbol}${amount}`;
  }

  /**
   * Get product type category
   */
  function getProductCategory(productType) {
    if (PRODUCT_TYPES.wipers.includes(productType)) return 'wipers';
    if (PRODUCT_TYPES.fuelCaps.includes(productType)) return 'fuelCaps';
    if (PRODUCT_TYPES.evCables.includes(productType)) return 'evCables';
    if (PRODUCT_TYPES.carMats.includes(productType)) return 'carMats';
    return null;
  }

  /**
   * Generate product card HTML
   */
  function createProductCard(product, variant) {
    const productImage = product.images.edges[0]?.node?.url || CONFIG.placeholderImage;
    const productLink = `/products/${product.handle}`;
    const variantIdShort = variant.id.substring(29);
    const formattedPrice = formatPrice(variant.price.amount, variant.price.currencyCode);
    const isAvailable = variant.quantityAvailable > 0;
    const category = getProductCategory(product.productType);

    const buttonHtml = isAvailable
      ? `<button id="quick-add-${variantIdShort}-submit"
            type="submit"
            name="add"
            class="quick-add__submit button button--full-width button--secondary"
            aria-haspopup="dialog"
            aria-live="polite"
            data-sold-out-message="false">
          <span>Add to cart</span>
          <div class="loading-overlay__spinner hidden">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>`
      : category === 'carMats'
        ? `<a href="${productLink}" class="quick-add__submit button button--full-width button--secondary">
            See more options
          </a>`
        : `<button id="quick-add-${variantIdShort}-submit"
              type="submit"
              name="add"
              class="quick-add__submit button button--full-width button--secondary"
              aria-haspopup="dialog"
              aria-live="polite"
              data-sold-out-message="true"
              disabled>
            <span>Sold out</span>
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          </button>`;

    return `
      <li class="grid__item">
        <div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
            <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy" style="max-width: 100%;">
                </div>
              </div>
              <div class="card__content">
                <div class="card__information"></div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${productLink}" class="full-unstyled-link caption-01">${product.title}</a>
                </h3>
                <div class="card__information">
                  <span class="caption-large light"></span>
                  <div class="price price--on-sale">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${formattedPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="price-item price-item--sale price-item--last heading04M">${formattedPrice}</span>
                      </div>
                      <small class="unit-price caption hidden">
                        <span class="visually-hidden">Unit price</span>
                        <span class="price-item price-item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span class="visually-hidden">&nbsp;per&nbsp;</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-add no-js-hidden">
                <product-form>
                  <form method="post" action="/cart/add" id="quick-add-${variantIdShort}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${variantIdShort}">
                    ${buttonHtml}
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </div>
      </li>`;
  }

  /**
   * Generate Your Vehicle section HTML
   */
  function createYourVehicleHtml(vehicleData, collectionHandle) {
    const headingText = COLLECTION_HEADINGS[collectionHandle] || 'YOUR VEHICLE';
    const { reg = '', make = '', model = '', body = '', fuel = '' } = vehicleData;

    return `
      <div class="inner page-width">
        <div class="guaranteed-fit body-01">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2 4-4"></path>
          </svg>
          Guaranteed Fit
        </div>
        <h2 class="display02M">${headingText}</h2>
        ${reg ? `<div class="icon-reg"><div class="your-vehicle__reg">${reg}</div></div>` : ''}
        <div class="your-vehicle__details">
          <p class="body-01">${make} ${model}<br>${body}<br>${fuel}</p>
        </div>
        <div class="your-vehicle__buttons vehicle-confirm__buttons">
          <a href="/pages/find-wiper-blades" class="button button--primary">Change my vehicle</a>
        </div>
        <div class="trustpilot">
          <p class="caption-01">
            Excellent
            <img src="${CONFIG.trustpilotImage}" alt="Trustpilot Rating">
            <a href="https://www.trustpilot.com/review/www.vipacarparts.com" target="_blank">18,065 Reviews on</a>
            <img src="${CONFIG.trustpilotLogo}" alt="Trustpilot">
          </p>
        </div>
      </div>`;
  }

  /**
   * Get vehicle data from localStorage
   */
  function getVehicleData() {
    const regResult = localStorage.getItem('regResult');
    if (regResult) {
      const data = JSON.parse(regResult);
      return {
        reg: data.reg || '',
        make: data.make || '',
        model: data.model || '',
        body: data.body || '',
        fuel: data.fuel_type || ''
      };
    }

    const manualOptions = localStorage.getItem('manual_selected_options');
    if (manualOptions) {
      const data = JSON.parse(manualOptions);
      return {
        reg: '',
        make: data.make || '',
        model: data.model || '',
        body: data.bodyStyle || '',
        fuel: data.fuelType !== '0' ? data.fuelType : ''
      };
    }

    return null;
  }

  /**
   * Get collection handle from URL
   */
  function getCollectionHandle() {
    const pathSegments = window.location.pathname.split('/');
    const collectionsIndex = pathSegments.indexOf('collections');
    return collectionsIndex !== -1 ? pathSegments[collectionsIndex + 1] : '';
  }

  /**
   * Get product IDs from URL params
   */
  function getProductIdsFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const idsParam = urlParams.get('ids');
    if (!idsParam) return [];
    return idsParam.split(',').map(id => `gid://shopify/Product/${id}`);
  }

  /**
   * GraphQL query for fetching products
   */
  const PRODUCTS_QUERY = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          productType
          blade_size: metafield(namespace: "custom", key: "blade_size") {
            value
          }
          images(first: 1) {
            edges {
              node {
                id
                altText
                url(transform: { maxWidth: 400 })
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
                title
                sku
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
              }
            }
          }
        }
      }
    }
  `;

  /**
   * Fetch products from Shopify Storefront API
   */
  async function fetchProducts(productIds) {
    const response = await fetch(`${CONFIG.shopifyDomain}/api/${CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.storefrontAccessToken
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: { ids: productIds }
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.data.nodes.filter(Boolean);
  }

  /**
   * Render products to their respective grids
   */
  function renderProducts(products) {
    const productsByCategory = {
      wipers: [],
      fuelCaps: [],
      evCables: [],
      carMats: []
    };

    // Categorize products
    products.forEach(product => {
      if (!product || !product.variants?.edges?.length) return;

      const category = getProductCategory(product.productType);
      if (category) {
        const variant = product.variants.edges[0].node;
        productsByCategory[category].push(createProductCard(product, variant));
      }
    });

    // Render to grids
    const gridMappings = {
      wipers: 'product-grid',
      fuelCaps: 'product-grid-caps',
      evCables: 'product-grid-ev',
      carMats: 'product-grid-car-mats'
    };

    Object.entries(gridMappings).forEach(([category, gridId]) => {
      const grid = document.getElementById(gridId);
      if (grid) {
        grid.innerHTML = productsByCategory[category].join('');
      }
    });

    // Empty section messages based on collection
    const EMPTY_MESSAGES = {
      'car-mats-for-your-vehicle': {
        mats: "Sorry — we don't have mats available for your specific vehicle just yet. However, have you thought about upgrading your wiper blades? Compatible wiper options are displayed below."
      },
      'wipers-for-your-vehicle': {
        mats: "Sorry — we don't have mats available for your specific vehicle just yet."
      }
    };

    // Handle empty sections
    const handleEmptySection = (titleId, gridId, products, emptyMessage = null) => {
      if (products.length === 0) {
        const title = document.getElementById(titleId);
        const grid = document.getElementById(gridId);

        if (emptyMessage && title) {
          // Show message instead of hiding, with custom styling
          const h2 = title.querySelector('h2');
          h2.textContent = emptyMessage;
          h2.style.fontSize = 'xx-large';
          if (grid?.parentElement) grid.parentElement.style.display = 'none';
        } else {
          // Hide both title and grid
          if (title) title.style.display = 'none';
          if (grid?.parentElement) grid.parentElement.style.display = 'none';
        }
      }
    };

    const collectionHandle = getCollectionHandle();
    const messages = EMPTY_MESSAGES[collectionHandle] || {};

    handleEmptySection('car_mats_collection', 'product-grid-car-mats', productsByCategory.carMats, messages.mats);
    handleEmptySection('wipers_collection', 'product-grid', productsByCategory.wipers);
  }

  /**
   * Render vehicle information
   */
  function renderVehicleInfo() {
    const yourVehicleDiv = document.getElementById('your-vehicle');
    if (!yourVehicleDiv) return;

    const vehicleData = getVehicleData();
    if (!vehicleData) return;

    const collectionHandle = getCollectionHandle();
    yourVehicleDiv.innerHTML = createYourVehicleHtml(vehicleData, collectionHandle);
  }

  /**
   * Initialize the component
   */
  async function init() {
    const productIds = getProductIdsFromUrl();
    if (productIds.length === 0) return;

    try {
      const products = await fetchProducts(productIds);
      renderProducts(products);
      renderVehicleInfo();
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
